import { forwardRef } from 'react'

import TextField, { TextFieldProps } from '@material-ui/core/TextField'

const TextInput = forwardRef((props: TextFieldProps, ref) => {
  return (
    <TextField
      {...props}
      inputRef={ref}
      InputProps={{
        inputProps: { autoCapitalize: 'none', ...props.InputProps?.inputProps },
        ...props.InputProps,
      }}
      size="small"
      variant="outlined"
      fullWidth
    />
  )
})

export default TextInput
